<template>
  <section class="invoice-add-wrapper">
    <b-row class="invoice-add">
      <!-- Col: Left (Invoice Container) -->
      <b-col
        cols="12"
        xl="9"
        md="8"
      >
        <b-form @submit.prevent>
          <b-card
            no-body
            class="invoice-preview-card"
          >
            <!-- Header -->
            <b-card-body class="invoice-padding pb-0">
              <div
                class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0"
              >
                <!-- Header: Left Content -->
                <div>
                  <div class="logo-wrapper">
                    <img
                      src="@/assets/images/logo/logo.png"
                      width="200px"
                      height="auto"
                    >
                    <h3 class="text-primary invoice-logo" />
                  </div>
                  <b-card-text class="mb-0">
                    RUE EL KOUNAITRA 1-dar Chaabene El Fehri
                  </b-card-text>
                  <b-card-text class="mb-0">
                    gsr-cle1@hotmail.fr
                  </b-card-text>
                  <b-card-text class="mb-0">
                    +216 97 607 740
                  </b-card-text>
                  <b-card-text class="mb-0">
                    MF : 1082793F/A/M/000
                  </b-card-text>
                </div>

                <!-- Header: Right Content -->
                <div>
                  <b-row>
                    <b-col>
                      <h4
                        style="color: black"
                        class="text-center"
                      >
                        Bon de sortie N°
                      </h4>
                    </b-col>
                    <b-col>
                      <b-input-group>
                        <b-input-group-prepend is-text>
                          <feather-icon icon="HashIcon" />
                        </b-input-group-prepend>
                        <b-form-input
                          id="invoice-data-id"
                          v-model="last"
                        />
                      </b-input-group>
                    </b-col>
                  </b-row>
                  <b-row class="mt-1">
                    <b-col>
                      <h4
                        style="color: black"
                        class="text-center"
                      >
                        Date
                      </h4>
                    </b-col>
                    <b-col>
                      <flat-pickr
                        v-model="invoiceData.date"
                        class="form-control"
                      />
                    </b-col>
                  </b-row>
                  <b-row class="mt-1">
                    <b-col>
                      <h4
                        style="color: black"
                        class="text-center"
                      >
                        Date de début de validité
                      </h4>
                    </b-col>
                    <b-col>
                      <flat-pickr
                        v-model="invoiceData.start_validity_date"
                        class="form-control"
                      />
                    </b-col>
                  </b-row>
                  <b-row class="mt-1">
                    <b-col>
                      <h4
                        style="color: black"
                        class="text-center"
                      >
                        Date de fin de validité
                      </h4>
                    </b-col>
                    <b-col>
                      <flat-pickr
                        v-model="invoiceData.end_validity_date"
                        class="form-control"
                      />
                    </b-col>
                  </b-row>

                  <b-row class="mt-1">
                    <b-col>
                      <h4
                        style="color: black"
                        class="text-center"
                      >
                        Secteur
                      </h4></b-col>
                    <b-col>
                      <v-select
                        v-model="invoiceData.states"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="states"
                        label="name"
                        input-id="invoice-data-client"
                        :clearable="false"
                        :reduce="(state) => state.id"
                        multiple
                      />
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-card-body>
            <!-- Spacer -->
            <hr class="invoice-spacing">
            <!-- Invoice Client & Payment Details -->
            <b-card-body class="invoice-padding pt-0">
              <b-row>
                <!-- Col: Invoice To -->
                <b-col
                  cols="12"
                  xl="6"
                  class="mb-lg-1"
                >
                  <h6 class="mb-1">
                    Chauffeur
                  </h6>
                  <!-- Select Client -->
                  <v-select
                    v-model="invoiceData.driver"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="drivers"
                    label="name"
                    input-id="invoice-data-client"
                    :clearable="false"
                  />

                  <!-- Selected Client -->
                </b-col>
                <feather-icon
                  size="16"
                  icon="XOctagonIcon"
                  class="cursor-pointer mt-4"
                  @click="invoiceData.driver = null"
                />

                 <!-- Col: Invoice To -->
                <b-col
                  cols="12"
                  xl="6"
                  class="mb-lg-1"
                >
                  <h6 class="mb-1">
                    Camion
                  </h6>
                  <!-- Select Client -->
                  <v-select
                    v-model="invoiceData.truck"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="trucks"
                    label="serial_number"
                    input-id="invoice-data-client"
                    :clearable="false"
                  />

                  <!-- Selected Client -->
                </b-col>
                <feather-icon
                  size="16"
                  icon="XOctagonIcon"
                  class="cursor-pointer mt-4"
                  @click="invoiceData.truck = null"
                />
              </b-row>

              
            </b-card-body>

            <!-- Items Section -->
            <b-card-body class="invoice-padding form-item-section">
              <div
                ref="form"
                class="repeater-form"
                :style="{ height: trHeight }"
              >
                <b-row
                  v-for="(item, index) in invoiceData.items"
                  :key="index"
                  ref="row"
                  class="pb-2"
                >
                  <!-- Item Form -->
                  <!-- ? This will be in loop => So consider below markup for single item -->
                  <b-col cols="12">
                    <!-- ? Flex to keep separate width for XIcon and SettingsIcon -->
                    <div class="d-none d-lg-flex">
                      <b-row class="flex-grow-1 px-1">
                        <!-- Single Item Form Headers -->

                        <b-col
                          cols="12"
                          lg="4"
                        >
                          Labelle
                        </b-col>

                        <b-col
                          cols="12"
                          lg="3"
                        >
                          Quantité
                        </b-col>
                        <b-col
                          cols="12"
                          lg="2"
                        >
                          Prix total
                        </b-col>
                      </b-row>
                      <div class="form-item-action-col" />
                    </div>
                    <!-- Form Input Fields OR content inside bordered area  -->
                    <!-- ? Flex to keep separate width for XIcon and SettingsIcon -->
                    <div class="d-flex border rounded">
                      <b-row class="flex-grow-1 p-2">
                        <!-- Single Item Form Headers -->

                        <b-col
                          cols="12"
                          lg="4"
                        >
                          <label class="d-inline d-lg-none">Labelle</label>
                          <b-form-input
                            v-if="item.name == ''"
                            v-model="item.name"
                            class="mb-2"
                          />
                          <v-select
                            v-else
                            v-model="item.product"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="products"
                            label="name"
                            :clearable="false"
                            class="mb-2 item-selector-title"
                            placeholder="Select Item"
                            @input="setSelected(item.product, index)"
                          />
                        </b-col>

                        <b-col
                          cols="12"
                          lg="3"
                        >
                          <label class="d-inline d-lg-none">Qty</label>
                          <b-form-input
                            v-model="item.qty"
                            value="1"
                            type="number"
                            class="mb-2"
                          />
                        </b-col>

                        <b-col
                          cols="12"
                          lg="2"
                        >
                          <label class="d-inline d-lg-none">Prix</label>
                          <p
                            v-if="item.product.sales_price_ht"
                            class="mb-1"
                          >
                            {{
                              (item.product.sales_price_ht * item.qty).toFixed(
                                3
                              )
                            }}
                          </p>
                        </b-col>
                      </b-row>
                      <div
                        class="d-flex flex-column justify-content-between border-left py-50 px-25"
                      >
                        <feather-icon
                          size="16"
                          icon="XIcon"
                          class="cursor-pointer"
                          @click="removeItem(index)"
                        />
                      </div></div></b-col>
                </b-row>
              </div>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                size="sm"
                variant="primary"
                @click="addNewItem"
              >
                Ajouter produit
              </b-button>
            </b-card-body>

            <!-- Invoice Description: Total -->
            <b-card-body class="invoice-padding pb-0">
              <b-row>
                <!-- Col: Sales Persion -->
                <b-col
                  cols="12"
                  md="6"
                  class="mt-md-0 mt-3 d-flex align-items-center"
                  order="2"
                  order-md="1"
                />

                <!-- Col: Total -->
                <b-col
                  cols="12"
                  md="6"
                  class="mt-md-6 d-flex justify-content-end"
                  order="1"
                  order-md="2"
                >
                  <div class="invoice-total-wrapper">
                    <div
                      v-if="totalHT"
                      class="invoice-total-item"
                    >
                      <p class="invoice-total-title">
                        Total HT:
                      </p>
                      <p class="invoice-total-amount">
                        {{ totalHT.toFixed(3) }} DT
                      </p>
                    </div>
                    <div
                      v-else
                      class="invoice-total-item"
                    >
                      <p class="invoice-total-title">
                        Total HT:
                      </p>
                      <p class="invoice-total-amount">
                        0
                      </p>
                    </div>

                    <div class="invoice-total-item">
                      <p class="invoice-total-title">
                        TVA:
                      </p>
                      <p
                        v-if="totalHT"
                        class="invoice-total-amount"
                      >
                        {{ tax }} DT
                      </p>
                      <p
                        v-else
                        class="invoice-total-amount"
                      >
                        0
                      </p>
                    </div>
                    <hr class="my-50">
                    <div
                      v-if="totalHT"
                      class="invoice-total-item"
                    >
                      <p class="invoice-total-title">
                        Prix T.T.C:
                      </p>
                      <p class="invoice-total-amount">
                        {{ totalTTC }} DT
                      </p>
                    </div>
                    <div
                      v-else
                      class="invoice-total-item"
                    >
                      <p class="invoice-total-title">
                        Prix T.T.C:
                      </p>
                      <p class="invoice-total-amount">
                        0
                      </p>
                    </div>
                  </div></b-col></b-row>
            </b-card-body>

            <!-- Spacer -->
            <hr class="invoice-spacing">
          </b-card>
        </b-form>
      </b-col>

      <!-- Right Col: Card -->
      <b-col
        cols="12"
        md="4"
        xl="3"
        class="invoice-actions mt-md-0 mt-2"
      >
        <!-- Action Buttons -->
        <b-card>

          <b-button
            type="submit"
            variant="primary"
            class="mr-1"
            @click="save"
          >
            <b-spinner
              v-if="isLoading === true"
              small
            />
            Enregistrer
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <invoice-sidebar-add-new-customer />
  </section>
</template>

<script>
import { ref } from '@vue/composition-api'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BButton,
  BCardText,
  BForm,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  VBToggle,
  BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import axiosIns from '@/libs/axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import InvoiceSidebarAddNewCustomer from './CreateCustomer.vue'

export default {
  name: 'CreateExitVoucher',
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BCardText,
    BForm,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    flatPickr,
    vSelect,
    InvoiceSidebarAddNewCustomer,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    BSpinner,
  },

  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  mixins: [heightTransition],

  data() {
    return {
      last: [],
      drivers: [],
      trucks: [],
      states: [],
      barcode: '',
      exist: false,
      isLoading: false,
    }
  },
  computed: {

    totalHT() {
      return this.invoiceData.items.reduce(
        (accumulator, item) => accumulator + item.product.sales_price_ht * item.qty,
        0,
      )
    },
    totalTTC() {
      return (Number(this.totalHT) + Number(this.tax)).toFixed(3)
    },
    tax() {
      return this.invoiceData.items
        .reduce(
          (accumulator, item) => accumulator + item.product.sales_price_vat * item.qty,
          0,
        )
        .toFixed(3)
    },
  },

  mounted() {
    this.initTrHeight()
  },
  created() {
    this.getDrivers()
    this.getTrucks()
    this.getStates()
    this.getLastExitVoucher()
    window.addEventListener('resize', this.initTrHeight)
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {
    async getDrivers() {
      try {
        const { data } = await axiosIns.get('/drivers')
        this.drivers = data
      } catch (error) {
        console.log(error)
      }
    },
     async getTrucks() {
      try {
        const { data } = await axiosIns.get('/trucks')
        this.trucks = data
      } catch (error) {
        console.log(error)
      }
    },
    async getStates() {
      try {
        const { data } = await axiosIns.get('/states')
        this.states = data
      } catch (error) {
        console.log(error)
      }
    },

    async getLastExitVoucher() {
      const { data } = await axiosIns.get('/exit-vouchers/last/')
      this.last = data+1
    },

    setSelected(value, index) {
      const f = this.invoiceData.items.filter(item => item.product === value)
      if (f.length > 1) {
        this.removeItem(index)
        // eslint-disable-next-line operator-assignment
        f[0].qty = f[0].qty + 1
      } else {
        f[0].qty = 1
      }
    },

    async refresh() {
      this.exist = false
    },

    formatFn(date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      const day1 = day.substr(0, 2)

      return `${year}-${month.padStart(2, '0')}-${day1.padStart(2, '0')}`
    },

    withTitle(quantity, index) {
      this.$swal({
        title: 'Stock Alerte',
        icon: 'warning',
        text: `Quantité demandé est superieur au stock       il vous reste que ${quantity} pièce`,
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.removeItem(index)
        }
      })
    },

    showToast(variant, position, text) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Notification',
            icon: 'InfoIcon',
            text,
            variant,
          },
        },
        {
          position,
        },
      )
    },

    async save() {
      this.isLoading = true
      const date = new Date()
      const now = this.formatFn(date.toISOString())
      let driver
      if (this.invoiceData.driver) {
        driver = this.invoiceData.driver.id
      } else {
        driver = null
      }
      let truck
      if (this.invoiceData.truck) {
        truck = this.invoiceData.truck.id
      } else {
        truck = null
      }

      const obj = {
        number: this.last,
        date: this.invoiceData.date,
        driver,
        truck ,
        products: this.invoiceData.items,
        total_ht: this.totalHT.toFixed(3),
        total_ttc: this.totalTTC,
        tax: this.tax,
        date_today: now,
        states: this.invoiceData.states,
        date_start: this.invoiceData.start_validity_date,
        date_end: this.invoiceData.end_validity_date,
      }
      try {
        await axiosIns.post('/exit-vouchers/create/', obj)
        this.$router.push({ name: 'exit-vouchers' })
        this.showToast(
          'success',
          'top-center',
          'Bon de sortie ajouté avec succés',
        )
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        this.showToast('danger', 'top-center', e.toString())
      }
    },

    async addNewItem() {
      // this.$refs.form.style.overflow = 'hidden'
      const itemFormBlankItem = {
        product: {},
        qty: 1,
      }
      this.invoiceData.items.push(
        JSON.parse(JSON.stringify(itemFormBlankItem)),
      )
    },
    removeItem(index) {
      this.invoiceData.items.splice(index, 1)
      this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        // this.trSetHeight(this.$refs.form.scrollHeight)
      })
    },
  },
  setup() {
    const itemFormBlankItem = {
      product: {},
      qty: 1,
    }
    const orders = ref([])
    const current = new Date()

    const invoiceData = ref({
      id: '',
      driver: null,
      date: `${current.getFullYear()}-${
        current.getMonth() + 1
      }-${current.getDate()}`,

      // ? Set single Item in form for adding data
      items: [JSON.parse(JSON.stringify(itemFormBlankItem))],
      note: '',
    })

    const products = ref([])
    axiosIns.get('/products/for-sales').then(response => {
      products.value = response.data
    })

    return {
      invoiceData,
      products,
      itemFormBlankItem,
      orders,
    }
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
.invoice-add-wrapper {
  .add-new-client-header {
    padding: $options-padding-y $options-padding-x;
    color: $success;

    &:hover {
      background-color: rgba($success, 0.12);
    }
  }
}
</style>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "~@core/scss/base/components/variables-dark";

.form-item-section {
  background-color: $product-details-bg;
}

.form-item-action-col {
  width: 27px;
}

.repeater-form {
  // overflow: hidden;
  transition: 0.35s height;
}

.v-select {
  &.item-selector-title,
  &.payment-selector {
    background-color: #fff;

    .dark-layout & {
      background-color: unset;
    }
  }
}

.dark-layout {
  .form-item-section {
    background-color: $theme-dark-body-bg;

    .row .border {
      background-color: $theme-dark-card-bg;
    }
  }
}
</style>
